<template>
  <div class="button-mask">
    <div class="outside-mask"></div>
    <button
      class="button"
      :class="{ paused: value }"
      @click="toggleButton"
    ></button>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      toggleButton() {
        this.$emit('click', !this.value);
        this.$emit('input', !this.value);
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '~styles/scss/media.scss';
  .button {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    outline: none;

    border: 0;
    background: transparent;
    box-sizing: border-box;
    width: 0;
    height: 74px;
    transform: translateX(15%);

    border-color: transparent transparent transparent rgba(255, 255, 255, 0.6);
    transition: 0.2s all ease-in-out;
    cursor: pointer;

    border-style: solid;
    border-width: 37px 0 37px 60px;
    @media screen and (max-height: $m-h) {
      height: 37px;
      border-width: 18.5px 0 18.5px 30px;
    }
    @include respond-to(tablet) {
      height: 37px;
      border-width: 18.5px 0 18.5px 30px;
    }

    &.paused {
      border-style: double;
      border-width: 0px 0 0px 60px;
      opacity: 0;
      transition: all 0.2s ease-in-out;
      @media screen and (max-height: $m-h) {
        border-width: 0px 0 0px 30px;
      }
    }

    &:hover {
      border-color: transparent transparent transparent #fff;
    }
  }
  .button-mask,
  .outside-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .button-mask {
    .outside-mask {
      background-color: rgba(0, 0, 0, 0.15);
    }
    &:hover {
      .paused {
        opacity: 1;
      }
    }
  }
  .outside-mask {
    transition: background-color 0.2s ease-in-out;
  }
</style>



// WEBPACK FOOTER //
// src/components/SlideFragment/slideComponents/VideoPlayer/components/PlayButtonMask.vue